import type { AnyAction, ThunkAction } from '@reduxjs/toolkit'
import { createAsyncThunk } from '@reduxjs/toolkit'
import type { RootStateOrAny } from 'react-redux'

import { setBasketNumPortion } from 'actions/basket'
import { applyPromoCode } from 'actions/home'
import { redirect } from 'actions/redirect'
import { trackClickBuildMyBox } from 'actions/tracking'
import routesConfig from 'config/routes'
import { getBasketPostcode } from 'selectors/basket'

import type { State } from './boxPricesModels'

export const boxPricesBoxSizeSelected = createAsyncThunk(
  '',
  async (
    { numPersons, slug, section }: { numPersons: number; slug: string; section: string },
    { dispatch, getState },
  ) => {
    const state = getState() as State
    const postcode = getBasketPostcode(state as RootStateOrAny)
    const destination = postcode ? 'menu' : 'wizard'

    dispatch(trackClickBuildMyBox(`${numPersons} people`, destination, section))
    dispatch(setBasketNumPortion(numPersons))

    if (destination === 'menu') {
      dispatch(redirect(routesConfig.client.menu))
    } else {
      await dispatch(applyPromoCode() as ThunkAction<void, unknown, unknown, AnyAction>)

      dispatch(redirect(`${routesConfig.client.signup}/${slug}`))
    }
  },
)
